import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation, NavLink } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "../assets/css/JoinUs.css";
import Swal from "sweetalert2";
import { baseurl } from "../utility/helper";
import HiddenPayuForm from "../components/forms/HiddenPayuForm";
import FileUpload from "../components/forms/FileUpload";
import Pretest from "./Pretest";

const JoinUs = ({ testId }) => {
  const Member_count = sessionStorage.getItem("members_in_india");
  const location = useLocation();
  const { state } = location || {};
  const Candidateid = parseInt(sessionStorage.getItem("CandidateID")) || null;
  const Candidatepriviledge = parseInt(sessionStorage.getItem("Candidatepriviledge"));
  const defaultTab = state?.tab || "#one"; 
  const [testData, setTestData] = useState(null);
  const [fileuploded, setFileUploded] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fees, setFees] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [tests, setTests] = useState([]);
  const [notes, setNotes] = useState([]);
  const [formData, setFormData] = useState({
    mobileNumber: "",
    firstName: "",
    lastName: "",
    email: "",
    gender: "",
    dob: "",
    address: "",
    state: "",
    city: "",
    pincode: "",
    document: null, 
  });

  useEffect(() => {
      if (defaultTab) {
        // Simulate a click to open correct tab
        const tabElement = document.querySelector(`a[href="${defaultTab}"]`);
        if (tabElement) {
          tabElement.click();
        }
      }
    }, [defaultTab]);
  // Fetch test data from the API
  useEffect(() => {
    const fetchTestData = async () => {
      try {
        const response = await axios.get(`${baseurl}/tests`, {
          params: {
            priviledge: Candidatepriviledge // 0 or 1
          }
        });
        if (response.data.length > 0) {
          setTestData(response.data); // Store all test data in state
        } else {
          console.log("No tests found");
        }
        setLoading(false); // Ensure loading is stopped after fetching
      } catch (error) {
        setError("Error fetching test data"); // Set error message
        setLoading(false); // Stop loading in case of error
      }
    };
    fetchData();
    fetchTestData();
    fetchFees();
  }, []);

  const fetchData = async () => {
    const res = await fetch(`${baseurl}/priortestaceept`);
    const data = await res.json();

    setTests(data.tests);   // [{ id, name }]
    setNotes(data.notes);   // [{ id, note }]
  };

  const fetchFees = async () => {
    try {
      const response = await axios.get(`${baseurl}/admin/getFees`);
      const feeRecord = response.data.find(fee => fee.fee_id === 3 || fee.fee_id === '3');

      if (feeRecord) {
        console.log("Fee Amount:", feeRecord.fees);
        setFees(feeRecord.fees);
        // Use feeRecord.fees as needed
      } else {
        console.warn("Fee with ID 4 not found");
      }
    } catch (error) {
      console.error("Error fetching fees:", error);
      alert("Failed to fetch fees.");
    }
  };

  if (loading) {
    return <p></p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  function formatDateWithSuffix(dateStr) {
    const date = new Date(dateStr);

    // Create a function to return the ordinal suffix
    const getOrdinalSuffix = (day) => {
      if (day > 3 && day < 21) return "th"; // covers 11th, 12th, 13th, etc.
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    // Format the date
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    const weekday = date.toLocaleString("default", { weekday: "long" });

    // Get the day with ordinal suffix
    const dayWithSuffix = `${day}${getOrdinalSuffix(day)}`;

    return `${weekday}, ${dayWithSuffix} ${month}, ${year}`;
  }

  function PrevArrow(props) {
    const { onClick } = props;
    return (
      <button className="slick-prev" onClick={onClick}>
        Previous
      </button>
    );
  }

  function NextArrow(props) {
    const { onClick } = props;
    return (
      <button className="slick-next" onClick={onClick}>
        Next
      </button>
    );
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const errors = {};
    const {
      mobileNumber,
      firstName,
      lastName,
      email,
      gender,
      dob,
      address,
      state,
      city,
      pincode,
    } = formData;

    if (!mobileNumber.match(/^\d{10}$/)) {
      errors.mobileNumber = "Mobile number must be 10 digits.";
    }
    if (!firstName) {
      errors.firstName = "First name is required.";
    }
    if (!lastName) {
      errors.lastName = "Last name is required.";
    }
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      errors.email = "Email is invalid.";
    }
    if (!gender) {
      errors.gender = "gender is required.";
    }
    if (!dob) {
      errors.dob = "Date of Birth is required.";
    }
    if (!address) {
      errors.address = "Address is required.";
    }
    if (!state) {
      errors.state = "State is required.";
    }
    if (!city) {
      errors.city = "City is required.";
    }
    if (!pincode) {
      errors.pincode = "pincode is required.";
    }

    return errors;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    try {
      const response = await axios.post(`${baseurl}/testcandidate`, {
        mobile: formData.mobileNumber,
        firstname: formData.firstName,
        lastname: formData.lastName,
        email: formData.email,
        gender: formData.gender,
        dob: formData.dob,
        address: formData.address,
        state: formData.state,
        city: formData.city,
        pincode: formData.pincode,
        education: formData.education,
      });
      // Show success message using SweetAlert
      Swal.fire({
        title: "Success!",
        text: "Form Submitted successfully! Plz login as a Candidate and Make Payment",
        icon: "success",
        confirmButtonText: "OK",
      });

      // Optionally, reset the form or redirect the user
      setFormData({
        mobileNumber: "",
        firstName: "",
        lastName: "",
        email: "",
        gender: "",
        dob: "",
        address: "",
        state: "",
        city: "",
        pincode: "",
        education: "",
        document: null, 
      });
      setFormErrors({});
    } catch (error) {
      console.error("Error registering Test:", error);
      // Check if the error response indicates that the candidate is already registered
      if (error.response && error.response.status === 409) {
        Swal.fire({
          title: "Already Registered!",
          text: "You are already registered as a Candidate. Please login.",
          icon: "info",
          confirmButtonText: "Candidate Login",
        }).then((result) => {
          if (result.isConfirmed) {
            // Navigate to the /Candidatelogin page
            // window.location.href = '/Candidatelogin'; // Use this for a full page reload
            // Alternatively, if you are using React Router, you can use:
            navigate("/Candidatelogin");
          }
        });
      } else if (error.response && error.response.status === 403) {
        // Check if the error response indicates that the user is already a member
        Swal.fire({
          title: "Membership Alert!",
          text: "You are already a member, You Cannot Register For The Prior-Evidence.",
          icon: "info",
          confirmButtonText: "OK",
        });
      } else {
        // Handle other error responses
        Swal.fire({
          title: "Error!",
          text: "There was an error registering the test. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };

  const SubmitPayment = async () => {
    try {
      // Step 1: Check Profile Completion
      const userId = parseInt(sessionStorage.getItem("CandidateID")) || null;
      if (!userId) {
        alert("Candidate ID not found. Please log in again.");
        return;
      }

      const profileCheckResponse = await axios.get(
        `${baseurl}/candidate/check_profile/${userId}`
      );

      if (
        profileCheckResponse.status !== 200 ||
        !profileCheckResponse.data.completed
      ) {
        Swal.fire({
          title: "Error!",
          text: "Your profile is incomplete. Please complete your profile before proceeding with payment.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      // Step 2: Proceed with Payment
      // const paymentData = {
      //   amount: 1000, // Example: Rs. 1000
      //   currency: 'INR',
      //   name: formData.firstname + ' ' + formData.lastname,
      //   description: `Test Payment for ${testData.test_title}`,
      //   orderId: `ORD-${Date.now()}`,
      //   email: formData.email,
      //   mobile: formData.mobile,
      //   address: formData.address,
      //   city: formData.city,
      //   state: formData.state,
      //   pincode: formData.pincode,
      // };

      // // Initialize BoxPay
      // const boxpay = new BoxPay({
      //   apiKey: 'YOUR_BOXPAY_API_KEY',
      //   environment: 'sandbox', // Use 'production' for live
      // });

      // const result = await boxpay.createPayment(paymentData);

      // if (result.status === 'success') {
      //   console.log('Payment successful:', result);
      //   alert('Payment Successful! Transaction ID: ' + result.transactionId);
      // } else {
      //   console.error('Payment failed:', result);
      //   alert('Payment Failed! Please try again.');
      // }

      // Step 2: Simulate Payment Success (Static Data)
      console.log("Simulating Payment...");
      const fakePaymentResponse = {
        status: "success",
        transactionId: `TXN-${Date.now()}`,
        amount: 1000,
        currency: "INR",
      };

      if (fakePaymentResponse.status === "success") {
        console.log("Payment successful:", fakePaymentResponse);

        // Step 3: Generate Hall Ticket and Insert into Test Registration Table
        const registrationData = {
          candidateId: userId,
          feesID: fakePaymentResponse.amount,
          transactionId: fakePaymentResponse.transactionId,
        };

        const response = await axios.post(
          `${baseurl}/testcandidate/register_prior`,
          registrationData
        );

        if (response.status === 200) {
          Swal.fire({
            title: "Success!",
            text: `Payment Successful! Prior-Evidence register Successful.`,
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "Failed to Register Prior-Evidence. Please contact support.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } else {
        console.error("Payment failed:", fakePaymentResponse);
        Swal.fire({
          title: "Error!",
          text: "Payment Failed! Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error during payment:", error);
      alert("An error occurred. Please try again.");
    }
  };

  const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (file && file.type !== "application/pdf") {
    setFormErrors((prev) => ({
      ...prev,
      document: "Only PDF files are allowed.",
    }));
    return;
  }

  setFormData((prevData) => ({
    ...prevData,
    document: file,
  }));

  setFormErrors((prev) => ({
    ...prev,
    document: "",
  }));
};
// const tests = [
//     { name: "WAIS IV", color: "primary" },
//     { name: "ICIT - Indian Child Intelligence Test", color: "info" },
//     { name: "WPPSI III - released on 2002", color: "success" },
//     { name: "WPPSI IV - released on 2012", color: "warning" },
//     { name: "Stanford Binet IV - released on 1986", color: "danger" },
//     { name: "Stanford Binet V - released on 2004", color: "secondary" },
//     { name: "APM Only for age above 11 years.", color: "dark" },
//     { name: "CogAT", color: "primary" },
//     { name: "WISC III (Indian Adaptation by Mahandrika Bhat)", color: "info" },
//     { name: "WISC-IV published in 2003", color: "success" },
//     { name: "WISC-V published in 2014.", color: "warning" }
//   ];

//   const notes = [
//     "Mensa requires a Full Scale IQ score(FSIQ), so all sub-tests needed to obtain an FSIQ must be given.Supplemental sub-tests are not required unless they are substituted for a required sub-test with valid explanation for why it was substituted.",
//     "For the WSIC-IV only: Mensa India will accept the general abilities index(GAI) in cases where there is a significant difference (i.e. 11/2 or more standard deviations) between two index scores. For all other Wechsler tests, the GAI will not be accepted."
//   ];


  return (
    <div className="bacimage">
<section className="banner">
  <Slider {...settings}>

    {/* Slide 1 - Clean Image */}
    <div className="hero-slide">
      <img src="assets/img/herobanner.png" alt="Banner 1" />
       <div className="hero-content">
        <h1 className="hero-title">
          THE SOCIETY 
          <br />
          OF HIGH IQ PEOPLE
        </h1>
        <p className="hero-subtitle">
          Mensa is the largest and oldest high IQ society in the
          world. It is a non-profit organization open to people who
          score at the 98th percentile or higher on a standardised,
          supervised IQ or other approved intelligence test.
        </p>
       <p className="hero-title" style={{margin:'0'}}>{Member_count}</p>
      </div>
    </div>

    {/* Slide 2 - Text + Button */}
    <div className="hero-slide">
      <img src="assets/img/herobanner3.png" alt="Social Impact" />
      <div className="hero-content">
        <h1 className="hero-title">
          SOCIAL IMPACT
          <br />
          DHRUV &amp; TMNP
        </h1>
       
        <div className="hero-actions">
          <NavLink to="/Spotlight" className="hero-btn hero-btn--primary"> Click Here</NavLink>
        </div>
      </div>
    </div>

    {/* Slide 3 - Text + Button */}
    <div className="hero-slide">
      <img src="assets/img/herobanner.png" alt="Our Mission" />
      <div className="hero-content">
        <h1 className="hero-title">
          THE SOCIETY 
          <br />
          OF HIGH IQ PEOPLE
        </h1>
        <p className="hero-subtitle">
          Mensa is the largest and oldest high IQ society in the
          world. It is a non-profit organization open to people who
          score at the 98th percentile or higher on a standardised,
          supervised IQ or other approved intelligence test.
        </p>
       <p className="hero-title" style={{margin:'0'}}>{Member_count}</p>
      </div>
    </div>

  </Slider>
</section>

      <div className="event" style={{ marginTop: "20px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <nav
                className="wow fadeInDown animated"
                data-animation="fadeInDown animated"
                data-delay=".2s"
                style={{ visibility: "visible", animationName: "fadeInDown" }}
              >
                <div
                  className="nav nav-tabs nav-fill"
                  id="nav-tab"
                  role="tablist"
                >
                  <a
                    className={`nav-item nav-link ${defaultTab === "#one" ? "active show" : ""}`}
                    id="nav-home-tab"
                    data-toggle="tab"
                    href="#one"
                    role="tab"
                    aria-selected={defaultTab === "#one"}
                  >
                    <div className="nav-content">
                      <strong>Why Join MENSA?</strong>
                    </div>
                  </a>

                  {/* <NavLink to={"/Pretest"} className="nav-item nav-link">
                    <div className="nav-content">
                      <strong>Online Mensa Pre-Test</strong>
                    </div>
                  </NavLink> */}
                  {/* ✅ NEW TAB FIVE */}
                  <a
                    className={`nav-item nav-link ${defaultTab === "#five" ? "active show" : ""}`}
                    data-toggle="tab"
                    href="#five"
                    role="tab"
                  >
                    <div className="nav-content">
                      <strong>Online Mensa Pre-Test</strong>
                    </div>
                  </a>

                  <a
                    className={`nav-item nav-link ${defaultTab === "#two" ? "active show" : ""}`}
                    id="nav-profile-tab"
                    data-toggle="tab"
                    href="#two"
                    role="tab"
                    aria-selected={defaultTab === "#two"}
                  >
                    <div className="nav-content">
                      <strong>Book Your Test</strong>
                    </div>
                  </a>

                  <a
                    className={`nav-item nav-link ${defaultTab === "#three" ? "active show" : ""}`}
                    id="nav-contact-tab"
                    data-toggle="tab"
                    href="#three"
                    role="tab"
                    aria-selected={defaultTab === "#three"}
                  >
                    <div className="nav-content">
                      <strong>Prior Evidence</strong>
                    </div>
                  </a>

                  <a
                    className={`nav-item nav-link ${defaultTab === "#four" ? "active show" : ""}`}
                    id="nav-contact-tab2"
                    data-toggle="tab"
                    href="#four"
                    role="tab"
                    aria-selected={defaultTab === "#four"}
                  >
                    <div className="nav-content">
                      <strong>Joining FAQ</strong>
                    </div>
                  </a>
                </div>
              </nav>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div
                className="tab-content wow fadeInDown animated"
                data-animation="fadeInDown animated"
                data-delay=".2s"
                id="nav-tabContent"
                style={{ visibility: "visible", animationName: "fadeInDown" }}
              >
                <div
                  className={`tab-pane fade ${defaultTab === "#one" ? "show active" : ""}`}
                  id="one"
                  href="#one"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                >
                  <div className="row mb-30">
                    <div className="col-lg-12">
                      <h1>Why Should I Join Mensa?</h1>
                      <p>
                        There are many intelligent reasons to join Mensa.
                        Whether you actively attend Mensa meetings or simply
                        relish the intellectual stimulation that membership
                        promotes, you’ll find the benefits of Mensa membership
                        to be numerous indeed.
                      </p>
                      <hr></hr>
                      <h1>Does Mensa Provide Intellectual Stimulation?</h1>
                      <p>
                        Mensa provides intriguing ways to flex your mental
                        muscles. You’ll find intellectual resources in the
                        national MInd magazines, in local email / whatsapp
                        groups, and at local, national and international
                        conventions. Whatever your passion, there’s almost
                        certain to be a Special Interest Group (SIG) filled with
                        other Mensans who share it! Mensa world-wide offers
                        approximately 200 SIGs, in mind-boggling profusion from
                        African Violets to zoology. Along the way you’ll find
                        microbiology, and systems analysis, but you’ll also find
                        Sherlock Holmes, chocolate and Star Trek. There are the
                        expected: biochemistry, space science, economics — and
                        the unexpected: poker, roller-skating, scuba diving,
                        UFOs and witchcraft. There are SIGs for bread making,
                        winemaking, cartooning, silversmithing, and clowning.
                        Heraldry, semantics and Egyptology co-exist with
                        beekeeping, motorcycling and tap dancing. Sports SIGs
                        cover the classics (baseball, basketball, and football)
                        and the not-so-classic (skeet shooting, hang gliding,
                        skydiving). And any Mensan who can’t find a SIG to join
                        can easily start one.
                      </p>
                      <hr></hr>
                      <h1>Does Mensa Provide Social Interaction?</h1>
                      <p>
                        Mensa meetings are anything but dull! Local groups meet
                        at least monthly. Often it’s for breakfast, lunch or
                        dinner or for get-togethers featuring a speaker or a
                        lively, freewheeling discussion. All are with fellow
                        members who share your intellectual interests. Of
                        course, participation in local group activities is
                        always entirely at your option
                      </p>
                      <hr></hr>
                      <h1>What Publications Come With Mensa Membership?</h1>
                      <p>
                        You will receive the national Magazine of Mensa India,
                        MInd Magazine with contributions by Mensans on a wide
                        variety of subjects. This will feature the “Mensa World
                        Journal,” an interesting and thought-provoking section
                        which contains views and information about Mensa around
                        the world. “Isolated M” is a popular and informative
                        newsletter sent to those members who are geographically
                        or otherwise isolated. Publication information is also
                        available for specific other National Groups.
                      </p>
                      <hr></hr>
                      <h1>
                        What Other Benefits Does Mensa Offer across the World?
                      </h1>
                      <p>
                        Many unique programs exist and they vary from country to
                        country.There is also a program that aids travelling
                        Mensans called SIGHT.
                      </p>
                      <hr></hr>
                      <h1>Does Mensa Help the Community?</h1>
                      <p>
                        Mensa members find opportunities to contribute to the betterment of society through volunteer activities within their communities. Do look up three of our programmes, Project Dhruv, the Underprivileged Gifted Child Identification and Nurturing Program, Project TMNP, the Tribal Mensa Nurturing Program and Project Dhruv-Tamilnadu, the Underprivileged Gifted Child Identification and Nurturing Program undertaken in association with Government of Tamilnadu
                      </p>
                     
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade ${defaultTab === "#two" ? "show active" : ""}`}
                  href="#two"
                  id="two"
                  role="tabpanel"
                  aria-labelledby="nav-profile-tab"
                >
                  <div className="row">
                    {testData && testData.length > 0 ? (
                      testData.map((test) => (
                        <div
                          key={test.test_id}
                          className="col-lg-4 col-md-6 col-12 mt-4 pt-2"
                        >
                          <div
                            className="card service-wrapper rounded border-0 shadow p-4"
                            style={{ height: "350px" }}
                          >
                            <div className="icon text-center text-custom h1 shadow rounded bg-white">
                              <span
                                className="uim-svg"
                                style={{ display: "inline-block" }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="1em"
                                >
                                  <rect
                                    width="20"
                                    height="15"
                                    x="2"
                                    y="3"
                                    className="uim-tertiary"
                                    rx="3"
                                  ></rect>
                                  <path
                                    className="uim-primary"
                                    d="M16,21H8a.99992.99992,0,0,1-.832-1.55469l4-6a1.03785,1.03785,0,0,1,1.66406,0l4,6A.99992.99992,0,0,1,16,21Z"
                                  ></path>
                                </svg>
                              </span>
                            </div>
                            <div className="content">
                              <h5 className="title">{test.test_title}</h5>
                              <br></br>

                              <h1 className="startdate">
                                {formatDateWithSuffix(test.test_start_time)}
                              </h1>
                              {/* <h1 className="enddate">End Date:- {formatDateWithSuffix(test.register_end_date)}</h1> */}
                              <p className="text-muted mt-3 mb-0">
                                <b>{test.test_desc}</b> <br />
                                <span className="venue-text">
                                {test.venue}
                                </span>
                              </p>
                              <div
                                className="mt-3"
                                style={{
                                  border: "2px solid #e3e7e9",
                                  borderRadius: "4px",
                                  padding: "5px",
                                  cursor: "pointer",
                                }}
                              >
                                <Link
                                  to="/ViewTest"
                                  state={{ testId: test.test_id }}
                                  className="text-custom"
                                >
                                  Know More{" "}
                                  <i className="mdi mdi-chevron-right"></i>
                                </Link>
                              </div>
                              <div className="big-icon h1 text-custom">
                                <span
                                  className="uim-svg"
                                  style={{ display: "inline-block" }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="1em"
                                  >
                                    <rect
                                      width="20"
                                      height="15"
                                      x="2"
                                      y="3"
                                      className="uim-tertiary"
                                      rx="3"
                                    ></rect>
                                    <path
                                      className="uim-primary"
                                      d="M16,21H8a.99992.99992,0,0,1-.832-1.55469l4-6a1.03785,1.03785,0,0,1,1.66406,0l4,6A.99992.99992,0,0,1,16,21Z"
                                    ></path>
                                  </svg>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <center
                        style={{
                          color: "red",
                          fontSize: "19px",
                          fontWeight: "500",
                        }}
                      >
                        <p>No tests available</p>
                      </center>
                    )}
                  </div>
                </div>

                <div
                  className={`tab-pane fade ${defaultTab === "#three" ? "show active" : ""}`}
                  href="#three"
                  id="three"
                  role="tabpanel"
                  aria-labelledby="nav-contact-tab"
                >
                  <div className="container prior-evidence">
                    <div className="row">
                      <div className="col-lg-8">
                        <div className="wrapper wrapper-content animated fadeInRight">
                          <div className="ibox-content m-b-sm border-bottom">
                            <div className="p-xs">
                              <h2>Joining Mensa India Using Prior Evidence</h2>
                              <span>
                                (Intelligence tests other than those conducted by Mensa India)
                              </span>
                            </div>
                            &nbsp;
                            <div className="row">
                              <p>
                                Mensa India has recently started accepting prior evidence based on approved standard intelligence tests administered by qualified Psychologists.
                              </p>
                            </div>
                          </div>
                          <div className="ibox-content m-b-sm border-bottom forum-container">
                            <div className="forum-title">
                              <div className="pull-right forums-desc">
                                <span>We now accept scores from several standardized intelligence tests, a partial list of which is given below. `</span>
                              </div>
                            </div>
                          <div className="cards shadow-lg border-0" style={{ borderRadius: "20px", overflow: "hidden", maxWidth: "900px", margin: "0 auto" }}>
                            {/* Header */}
                            <div className="card-header text-white text-center py-4" style={{ background: "linear-gradient(135deg, #00d2ff 0%, #3a7bd5 100%)" }}>
                              <h2 className="mb-0 fw-bold" style={{ letterSpacing: "1px", textShadow: "2px 2px 4px rgba(0,0,0,0.2)" }}>
                                TESTS ACCEPTED FOR PRIOR EVIDENCE
                              </h2>
                            </div>

                            {/* Body */}
                            <div className="card-body p-4" style={{ background: "linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%)" }}>
                              <div className="row g-3">
                                {tests.map((test, index) => (
                                  <div key={test.id} className="col-12 col-md-6">
                                    <div
                                      className="card h-100 border-0 shadow-sm"
                                      style={{
                                        borderRadius: "15px",
                                        transition: "all 0.3s ease",
                                        cursor: "pointer",
                                        borderLeft: "5px solid #0d6efd" // single neutral color
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-5px)";
                                        e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.15)";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.1)";
                                      }}
                                    >
                                      <div className="card-body d-flex align-items-center p-3">
                                        <div
                                          className="badge me-3"
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "18px",
                                            fontWeight: "bold",
                                            backgroundColor: "#002691"
                                          }}
                                        >
                                          {index + 1}
                                        </div>
                                        <span className="text-dark" style={{ fontSize: "15px" }}>
                                          {test.name}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ))}

                              </div>

                              {/* Notes Section */}
                              <div className="mt-5">
                                <div 
                                  className="cards border-0 shadow-sm"
                                  style={{ 
                                    borderRadius: "15px",
                                    background: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)"
                                  }}
                                >
                                  <div className="card-body p-4">
                                    <h5 className="text-danger fw-bold mb-3">
                                      <span style={{ fontSize: "24px" }}>⚠️</span>  Note: The Wechsler tests must be given in their entirety.
                                    </h5>
                                    {notes.map((n) => (
                                      <div key={n.id} className="mb-2 d-flex align-items-start">
                                        <span className="text-danger me-2" style={{ fontSize: "20px" }}>•</span>
                                        <p className="mb-0 text-dark" style={{ fontSize: "14px", lineHeight: "1.6" }}>
                                          {n.note}
                                        </p>
                                      </div>
                                    ))}

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          </div>
                          <div className="ibox-content m-b-sm border-bottom">
                            <div className="p-xs">
                              <span>
                                These standardized tests need to be administered by a qualified, trained person and under ethically appropriate conditions in order to be considered for eligibility for Mensa membership.
                              </span>
                            </div>
                            &nbsp;
                            <div className="row">
                              <p>
                               It is important to note that the tests are given for the purpose of admission into Mensa and not to quantify intelligence. A qualifying score indicates that you've tested at, or better than, 98 percent of the general population.
                              </p>
                            </div>
                            &nbsp;
                            <div className="row">
                              <p>
                               All evidence of prior testing will be appraised individually by our National Supervisory Psychologist , and may be renormed or restandardized. We will appraise all applications individually and reserve the right to make the final determination about the acceptability of any test.
                              </p>
                            </div>
                            &nbsp;
                            <div className="row">
                              <p>
                               The Mensa India National Supervisory Psychologist will consider each application individually and make a binary determination as to Mensa India membership eligibility, no further explanation or justification is to be expected and their decision will be final and binding.
                              </p>
                            </div>
                            &nbsp;
                            <div className="row">
                              <p>
                               Please note that the original or a notarized copy of the original will be required prior to acceptance in Mensa India though copies can be supplied for evaluation on payment of the required fees. If your evidence is accepted, we may require you to submit the original documents which will be returned after scrutiny by Mensa India.
                              </p>
                            </div>
                            &nbsp;
                            <div className="row">
                              <p>
                               In order for scores to be accepted for Mensa membership, tests must be administered by a neutral and qualified third party in a traditional testing environment under conditions appropriate for the norming standards of each test (such as Psychology Department of a university or a private psychologist).
                              </p>
                            </div>
                            &nbsp;
                            <div className="row">
                              <p>
                               Results from tests given by an institution, agency or clinic must include the full name of the test, the score and the percentile rank. This documentation must be on the letterhead of the institution, agency or clinic; it also must be signed by the psychologist responsible for the testing and must include the psychologist’s license number.
                              </p>
                            </div>
                            &nbsp;
                            <div className="row">
                              <p>
                               For further information pl see the relevant section ‘How do I get proof of my previous test score(s)?’ in the Mensa International website
                              </p>
                            </div>

                            &nbsp;
                            <div className="row">
                              <p>
                               If your test has been conducted by psychotherapist in private practice, please note that in addition to the above , the following also apply:
                              </p>
                              <p className="me-2">
                                <ol className="mb-0 text-dark" style={{ fontSize: "16px", lineHeight: "1" }}>
                                  <li>The examiner needs a minimum of a master’s degree in psychology or related field.</li>
                                  &nbsp;
                                   <li>Mensa India will also review the examiner’s background and experience when determining if the testing is eligible for acceptance.</li>
                                </ol>
                              </p>
                            </div>

                            &nbsp;
                            <div className="row">
                              <b>
                              How long does the evaluation process take?
                              </b>
                              <p>The evaluation will take 4-6 weeks. You can mail any questions in the interim to mensahq@mensaindia.org</p>
                            </div>

                             &nbsp;
                            <div className="row">
                              <b>
                              Does Mensa India accepts Online Tests?
                              </b>
                              <p>Mensa India does not accept the results of any online tests at this time.</p>
                            </div>

                              &nbsp;
                            <div className="row">
                              <b>
                             Is there an age limit for submitting prior evidence?
                              </b>
                              <p>Mensa India tests only children over 10 years of age. However, there is no age limit for joining Mensa, so if children below 10 years produce the results of authorized intelligence tests conducted by a professional psychologists, they will be evaluated and admitted to Mensa if they meet the required criteria.</p>
                            </div>

                              &nbsp;
                            <div className="row">
                              <b>Does Mensa India accept College Entrance exams like JEE, SAT , GRE , GMAT etc?</b>
                              <p>Mensa India does not accept college entrance tests as they are not considered by us to be strictly measures of intelligence. Many national Mensa chapters do accept such tests. If a candidate is accepted by another national Mensa on the basis of these scores, he is eligible to transfer to Mensa India on the basis of membership in that National Mensa.</p>
                            </div>

                            &nbsp;
                            <p><b>“A fee of INR 2000 is payable.”</b></p>

                              &nbsp;
                              {/* {Candidateid === null && (
                                <div className="row">
                                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                                    <button
                                      className="btn btn-primary"
                                      onClick={() =>
                                        navigate("/Candidatelogin", {
                                          state: { fromPage: "JoinUs", tab: "#three" }
                                        })
                                      }
                                    >
                                      Apply Now
                                    </button>
                                  </div>
                                </div>
                              )} */}
                          </div>
                        </div>
                      </div>
                      {/* </div> */}
                      {/* <br></br>
                    <div className="row"> */}
                      <div className="col-lg-4">
                            {Candidateid === null ? (
                              <div style={{ padding: "15px", textAlign: "center" }}>
                                <button
                                  className="btn btn-primary"
                                   onClick={() => navigate("/Candidatelogin", { state: { fromPage: "JoinUs", tab: "#three" } })}
                                >
                                  Apply Now
                                </button>
                              </div>
                            ) : (
                              <>
                              {Candidateid == null ? (
                                <form onSubmit={handleSubmit}>
                                  <div
                                    style={{
                                      padding: "15px",
                                      borderRadius: "15px",
                                      boxShadow: "0px 0px 10px 1px #0000007d",
                                    }}
                                  >
                                    <center>
                                      <h1>Please Upload the Document </h1>
                                    </center>
                                    <hr></hr>
                                    
                                    <div className="form-group">
                                      <label>Upload Document (PDF only)</label>
                                      <input
                                        type="file"
                                        name="document"
                                        accept="application/pdf"
                                        onChange={handleFileChange}
                                        className="form-control"
                                        required
                                      />
                                      {formErrors.document && (
                                        <small className="text-danger">{formErrors.document}</small>
                                      )}
                                      
                                    </div>
                                    
                                    <br></br>
                                    <center>
                                      <button
                                        type="submit"
                                        className="btn btn-primary"
                                        onClick={handleSubmit}
                                      >
                                        Submit
                                      </button>
                                    </center>
                                  </div>
                                </form>
                              ) : (
                                <div className="row" style={{ paddingTop: "10px" }}>
                                  {/* <button
                                    type="submit"
                                    className="btn btn-primary"
                                    onClick={SubmitPayment}
                                  >
                                    Make Payment
                                  </button> */}
                                  <FileUpload  setFileUploded={setFileUploded} />
                                  {fileuploded? 
                                  <HiddenPayuForm
                                    testId={`PriorEvidence`}
                                  />:
                                  <small className="text-danger">Max file size less than 1 MB</small>
                                  }
                                </div>
                              )}
                            </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade ${defaultTab === "#four" ? "show active" : ""}`}
                  href="#four"
                  id="four"
                  role="tabpanel"
                  aria-labelledby="nav-contact-tab"
                >
                  <div className="faq_area section_padding_130" id="faq">
                    <div className="container" style={{ marginTop: "-80px" }}>
                      <div className="row justify-content-center">
                        <div className="col-lg-12">
                          <div
                            className="section_heading text-center wow fadeInUp"
                            data-wow-delay="0.2s"
                          >
                            <h3>
                              <span>Frequently </span> Asked Questions
                            </h3>
                           
                            <div className="line"></div>
                          </div>
                        </div>
                      </div>
                      <div className="row justify-content-center">
                        <div className="col-lg-12">
                          <div
                            className="accordion faq-accordian"
                            id="faqAccordion"
                          >
                            {/* Question 1 */}
                            <div
                              className="card1 border-0 wow fadeInUp"
                              data-wow-delay="0.2s"
                            >
                              <div className="card-header" id="headingOne">
                                <h6
                                  className="mb-0 collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseOne"
                                  aria-expanded="true"
                                  aria-controls="collapseOne"
                                >
                                 What do I bring along?
                                  <span
                                    className="fa fa-plus-square"
                                    style={{
                                      right: "30px",
                                      position: "absolute",
                                      top: "35px",
                                    }}
                                  ></span>
                                </h6>
                              </div>
                              <div
                                className="collapse"
                                id="collapseOne"
                                aria-labelledby="headingOne"
                                data-parent="#faqAccordion"
                              ><br></br>
                                <div className="card-body">
                                  <p><ul><li>1 Photo identification proof (School / College id card is also accepted)</li></ul></p>
                                  <p><ul><li>Do not carry a calculator or writing pad as the same are not required</li></ul></p>
                                  <p><ul><li>At least two pencils, an eraser and a blue ballpoint pen</li></ul></p>
                                </div>
                              </div>
                            </div>

                            {/* Question 2 */}
                            <div
                              className="card1 border-0 wow fadeInUp"
                              data-wow-delay="0.3s"
                            >
                              <div className="card-header" id="headingTwo">
                                <h6
                                  className="mb-0 collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseTwo"
                                  aria-expanded="true"
                                  aria-controls="collapseTwo"
                                >
                                  What not to carry?
                                  <span
                                    className="fa fa-plus-square"
                                    style={{
                                      right: "30px",
                                      position: "absolute",
                                      top: "35px",
                                    }}
                                  ></span>
                                </h6>
                              </div>
                              <div
                                className="collapse"
                                id="collapseTwo"
                                aria-labelledby="headingTwo"
                                data-parent="#faqAccordion"
                              ><br></br>
                                <div className="card-body">
                                  <p>
                                    No bags, papers, pencil boxes, mobile phones, calculators, electronic devices, or any other items not specifically mentioned above are allowed inside the Testing room. Candidates shall be responsible for the safekeeping of any such items being carried by them.
                                  </p>
                                </div>
                              </div>
                            </div>

                            {/* Question 3 */}
                            <div
                              className="card1 border-0 wow fadeInUp"
                              data-wow-delay="0.4s"
                            >
                              <div className="card-header" id="headingThree">
                                <h6
                                  className="mb-0 collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseThree"
                                  aria-expanded="true"
                                  aria-controls="collapseThree"
                                >
                                  Is there an age qualification?
                                  <span
                                    className="fa fa-plus-square"
                                    style={{
                                      right: "30px",
                                      position: "absolute",
                                      top: "35px",
                                    }}
                                  ></span>
                                </h6>
                              </div>
                              <div
                                className="collapse"
                                id="collapseThree"
                                aria-labelledby="headingThree"
                                data-parent="#faqAccordion"
                              ><br></br>
                                <div className="card-body">
                                  <p>
                                    Tests for children aged between 10 years and 14 years 6 months and for candidates above 14 years and 6 months are different.
                                  </p>
                                  <p>
                                    As a matter of policy, Mensa India does not presently test children younger than 10 years. children younger than 10 years can join by submitting prior evidence.
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div
                              className="card1 border-0 wow fadeInUp"
                              data-wow-delay="0.4s"
                            >
                              <div className="card-header" id="headingFour">
                                <h6
                                  className="mb-0 collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseFour"
                                  aria-expanded="true"
                                  aria-controls="collapseFour"
                                >
                                  What is the kind of Test and how long will it last?
                                  <span
                                    className="fa fa-plus-square"
                                    style={{
                                      right: "30px",
                                      position: "absolute",
                                      top: "35px",
                                    }}
                                  ></span>
                                </h6>
                              </div>
                              <div
                                className="collapse"
                                id="collapseFour"
                                aria-labelledby="headingFour"
                                data-parent="#faqAccordion"
                              ><br></br>
                                <div className="card-body">
                                  <p>
                                    It is a non-verbal Test with multiple choice answers. It shall last about 60 minutes. No preparation is required because we test raw IQ.
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div
                              className="card1 border-0 wow fadeInUp"
                              data-wow-delay="0.4s"
                            >
                              <div className="card-header" id="headingFive">
                                <h6
                                  className="mb-0 collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseFive"
                                  aria-expanded="true"
                                  aria-controls="collapseFive"
                                >
                                 How and when shall I get the Test results?
                                  <span
                                    className="fa fa-plus-square"
                                    style={{
                                      right: "30px",
                                      position: "absolute",
                                      top: "35px",
                                    }}
                                  ></span>
                                </h6>
                              </div>
                              <div
                                className="collapse"
                                id="collapseFive"
                                aria-labelledby="headingFive"
                                data-parent="#faqAccordion"
                              ><br></br>
                                <div className="card-body">
                                  <p>
                                   The results are ordinarily emailed to the email id provided by you within 6-8 weeks from the Test date.
                                  </p>
                                </div>
                              </div>
                            </div>
                          
                          <div
                              className="card1 border-0 wow fadeInUp"
                              data-wow-delay="0.4s"
                            >
                              <div className="card-header" id="headingSix">
                                <h6
                                  className="mb-0 collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseSix"
                                  aria-expanded="true"
                                  aria-controls="collapseSix"
                                >
                                 Do the Test results provide my raw IQ score?
                                  <span
                                    className="fa fa-plus-square"
                                    style={{
                                      right: "30px",
                                      position: "absolute",
                                      top: "35px",
                                    }}
                                  ></span>
                                </h6>
                              </div>
                              <div
                                className="collapse"
                                id="collapseSix"
                                aria-labelledby="headingSix"
                                data-parent="#faqAccordion"
                              ><br></br>
                                <div className="card-body">
                                  <p>
                                   The Test results do not provide your raw IQ score. The results provide the percentile in which you are placed based on your score in the Test. Candidates who are placed in the 98th percentile or above are invited to join Mensa India.
                                  </p>
                                </div>
                              </div>
                            </div>
                          
                          <div
                              className="card1 border-0 wow fadeInUp"
                              data-wow-delay="0.4s"
                            >
                              <div className="card-header" id="headingSeven">
                                <h6
                                  className="mb-0 collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseSeven"
                                  aria-expanded="true"
                                  aria-controls="collapseSeven"
                                >
                                 If I do not qualify in the Test, can I appear again?
                                  <span
                                    className="fa fa-plus-square"
                                    style={{
                                      right: "30px",
                                      position: "absolute",
                                      top: "35px",
                                    }}
                                  ></span>
                                </h6>
                              </div>
                              <div
                                className="collapse"
                                id="collapseSeven"
                                aria-labelledby="headingSeven"
                                data-parent="#faqAccordion"
                              ><br></br>
                                <div className="card-body">
                                  <p>
                                   Candidates who do not qualify in a Test can appear again for the Tests only after a gap of 01 year. This is applicable all across Mensa India, and a candidate who has appeared for a Test anywhere in India can appear again, at the same or any other centre, only after a gap of 01 year. Please carry a copy of your previous Test results, at your next Test.
                                  </p>
                                </div>
                              </div>
                            </div>
                          
                              <div
                              className="card1 border-0 wow fadeInUp"
                              data-wow-delay="0.4s"
                            >
                              <div className="card-header" id="headingEight">
                                <h6
                                  className="mb-0 collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseEight"
                                  aria-expanded="true"
                                  aria-controls="collapseEight"
                                >
                                 Can a Mensa Test be conducted in my school / college?
                                  <span
                                    className="fa fa-plus-square"
                                    style={{
                                      right: "30px",
                                      position: "absolute",
                                      top: "35px",
                                    }}
                                  ></span>
                                </h6>
                              </div>
                              <div
                                className="collapse"
                                id="collapseEight"
                                aria-labelledby="headingEight"
                                data-parent="#faqAccordion"
                              ><br></br>
                                <div className="card-body">
                                  <p>
                                   Mensa Tests can be conducted at your school / college, especially for your school / college students. Please email us at mensahq@mensaindia.org for additional details.
                                  </p>
                                </div>
                              </div>
                            </div>     

                            <div
                              className="card1 border-0 wow fadeInUp"
                              data-wow-delay="0.4s"
                            >
                              <div className="card-header" id="headingNine">
                                <h6
                                  className="mb-0 collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseNine"
                                  aria-expanded="true"
                                  aria-controls="collapseNine"
                                >
                                 How do I contact Mensa India for any additional queries?
                                  <span
                                    className="fa fa-plus-square"
                                    style={{
                                      right: "30px",
                                      position: "absolute",
                                      top: "35px",
                                    }}
                                  ></span>
                                </h6>
                              </div>
                              <div
                                className="collapse"
                                id="collapseNine"
                                aria-labelledby="headingNine"
                                data-parent="#faqAccordion"
                              ><br></br>
                                <div className="card-body">
                                  <p>
                                   Please email all your queries to mensahq@mensaindia.org All emails are replied to by volunteers, in due course.
                                  </p>
                                </div>
                              </div>
                            </div>    
                            
                            <div
                              className="card1 border-0 wow fadeInUp"
                              data-wow-delay="0.4s"
                            >
                              <div className="card-header" id="headingEleven">
                                <h6
                                  className="mb-0 collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseEleven"
                                  aria-expanded="true"
                                  aria-controls="collapseEleven"
                                >
                                  What is the testing fees?
                                  <span
                                    className="fa fa-plus-square"
                                    style={{
                                      right: "30px",
                                      position: "absolute",
                                      top: "35px",
                                    }}
                                  ></span>
                                </h6>
                              </div>
                              <div
                                className="collapse"
                                id="collapseEleven"
                                aria-labelledby="headingEleven"
                                data-parent="#faqAccordion"
                              ><br></br>
                                <div className="card-body">
                                  <p>
                                    Rs. 1000
                                  </p>
                                </div>
                              </div>
                            </div>
                          
                            <div
                              className="card1 border-0 wow fadeInUp"
                              data-wow-delay="0.4s"
                            >
                              <div className="card-header" id="headingTen">
                                <h6
                                  className="mb-0 collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseTen"
                                  aria-expanded="true"
                                  aria-controls="collapseTen"
                                >
                                  What are the membership fees?
                                  <span
                                    className="fa fa-plus-square"
                                    style={{
                                      right: "30px",
                                      position: "absolute",
                                      top: "35px",
                                    }}
                                  ></span>
                                </h6>
                              </div>
                              <div
                                className="collapse"
                                id="collapseTen"
                                aria-labelledby="headingTen"
                                data-parent="#faqAccordion"
                              ><br></br>
                                <div className="card-body">
                                  <p>
                                    Joining fee is Rs. 1500 and you can choose membership term of Annual/5years/life Annual membership fee is Rs. 1200, 5 years membership fee is Rs. 5000 and life membership fee is Rs. 15000
                                  </p>
                                </div>
                              </div>
                            </div>
                          
                          </div>

                          

                          {/* Support Button */}
                          <div
                            className="support-button text-center d-flex align-items-center justify-content-center mt-4 wow fadeInUp"
                            data-wow-delay="0.5s"
                          >
                            <i className="fa fa-circle"></i>
                            <p className="mb-0 px-2">
                              Can't find your answers?
                            </p>
                            <a href="mailto:mensahq@mensaindia.org"> Contact us</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                 {/* ✅ TAB FIVE CONTENT */}
                <div className={`tab-pane fade ${defaultTab === "#five" ? "show active" : ""}`} id="five">
                  {/* Pre Test Page Content */}
                  
                  {/* Option 1: Direct Component */}
                  <Pretest />

                  {/* Option 2: Iframe (if external page) */}
                  {/* <iframe src="/Pretest" width="100%" height="600px" /> */}
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinUs;
